interface MetricCardProps {
  title: string
  value: string | number
  isHighlighted?: boolean
}

export function MetricCard({ title, value, isHighlighted = false }: MetricCardProps) {
  return (
    <div
      className={`rounded-lg p-3 ${
        isHighlighted ? 'bg-red-50 border border-red-200' : 'bg-muted/50'
      }`}
    >
      <p className="text-detail text-muted-foreground mb-1">{title}</p>
      <p className={`text-heading font-semibold ${isHighlighted ? 'text-red-600' : ''}`}>{value}</p>
    </div>
  )
}
